export const FETCH_ALL_INGREDIENTS_REQUEST = "FETCH_ALL_INGREDIENTS_REQUEST";
export const FETCH_ALL_INGREDIENTS_SUCCESS = "FETCH_ALL_INGREDIENTS_SUCCESS";
export const FETCH_ALL_INGREDIENTS_FAILURE = "FETCH_ALL_INGREDIENTS_FAILURE";

export const FILTER_INGREDIENT_REQUEST = "FILTER_INGREDIENT_REQUEST";
export const FILTER_INGREDIENT_SUCCESS = "FILTER_INGREDIENT_SUCCESS";
export const FILTER_INGREDIENT_FAILURE = "FILTER_INGREDIENT_FAILURE";

export const FILTER_N_INGREDIENT_REQUEST = "FILTER_N_INGREDIENT_REQUEST";
export const FILTER_N_INGREDIENT_SUCCESS = "FILTER_N_INGREDIENT_SUCCESS";
export const FILTER_N_INGREDIENT_FAILURE = "FILTER_N_INGREDIENT_FAILURE";
export const FILTER_N_INGREDIENT_RESET = "FILTER_N_INGREDIENT_RESET";
export const FILTER_N_INGREDIENT_INTERSECT = "FILTER_N_INGREDIENT_INTERSECT";

